/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  hasMany,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import type Tag from 'linced-admin/models/posts/tag';
import type UsageSet from 'linced-admin/models/schools/usage-set';

// Proto: posts.TagCategoryTemplate.
export default class TagCategory extends Model {
  declare [Type]: 'posts/tag-category';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @hasMany('posts/tag', { async: true, inverse: 'categoryId' })
  declare tags: AsyncHasMany<Tag>;

  @computed('tags.content.[]')
  get tagsArray() {
    return resolved(this.tags);
  }

  // Usage sets membership
  @hasMany('schools/usage-set', {
    async: true,
    inverse: 'tagCategoryTemplatesIds',
  })
  declare usageSetIds: AsyncHasMany<UsageSet>;

  @computed('usageSetIds.content.[]')
  get usageSetsArray() {
    return resolved(this.usageSetIds);
  }
}
